import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../shared/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(private dialog: MatDialog) {}

  openDeleteConfirmation(name: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Bekräfta radering',
        message: `Är du säker du vill radera "${name}"?`,
        confirmText: 'Radera',
        cancelText: 'Avbryt'
      },
      width: '400px',
      maxHeight: '90vh',
      autoFocus: 'dialog',
      restoreFocus: true,
      panelClass: 'confirmation-dialog-container'
    });

    return dialogRef.afterClosed();
  }

  unsavedNavigationConfirmation(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Osparade ändringar',
        message: 'Du har osparade ändringar. Är du villig att förlora förändringarna?',
        confirmText: 'Ja',
        cancelText: 'Avbryt'
      },
      width: '400px',
      maxHeight: '90vh',
      autoFocus: 'dialog',
      restoreFocus: true,
      panelClass: 'confirmation-dialog-container'
    });

    return dialogRef.afterClosed();
  }

  unsavedChangesConfirmation(): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Osparade ändringar',
        message: 'Du har osparade ändringar. Vill du verkligen stänga meddelandet?',
        confirmText: 'Ja',
        cancelText: 'Avbryt'
      },
      width: '400px',
      maxHeight: '90vh',
      autoFocus: 'dialog',
      restoreFocus: true,
      panelClass: 'confirmation-dialog-container'
    });

    return dialogRef.afterClosed();
  }
}
